module.exports = __webpack_public_path__ + "media/70.8ec42409.mp3";